"use client";

// Route-segment error boundary for the whole (app) dashboard shell. Widgets
// already handle their own fetch errors via useApi + PanelError, but nothing
// previously caught an uncaught render/runtime error — it would fall through
// to Next.js's unstyled default screen with no way back into the app.

import { useEffect } from "react";
import Link from "next/link";
import Icon from "../components/Icon";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
      <span
        className="neu-sm grid place-items-center w-16 h-16 rounded-2xl"
        style={{ color: "var(--danger)" }}
      >
        <Icon name="shield" size={26} />
      </span>
      <div>
        <p className="font-display text-lg text-text">Something went wrong</p>
        <p className="text-[13px] text-text-faint mt-1">
          This screen hit an unexpected error. Your data is safe — try again.
        </p>
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => reset()}
          className="neu-btn h-10 px-4 rounded-xl text-[13px] font-medium text-accent"
        >
          Try again
        </button>
        <Link
          href="/"
          className="neu-btn h-10 px-4 rounded-xl text-[13px] font-medium text-text-muted flex items-center"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
